import { useHasPermission } from "../auth/useClaims";

export const useCanViewLeave = () => useHasPermission("Leave.View");
export const useCanMarkLeave = () => useHasPermission("Leave.Mark");
